import React, { useState, useEffect, useRef } from 'react';
import styles from './Input.module.scss';
import dropdownicon from '../../../assets/Imagess/dropdownicon.svg';
import StatusContainer from '../../Molecules/Custom/StatusContainer';

const CustomizedSelect = ({
  options,
  value,
  onChange,
  placeholder,
  icon,
  noborder,
  label,
  status,
  errors,
  touched,
  name,
  required,
  grey,
}) => {
  const [selectedValue, setSelectedValue] = useState(value);
  const [selectedText, setSelectedText] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const selectRef = useRef(null);

  const handleSelect = (e, selectedValue) => {
    e.stopPropagation();
    setSelectedValue(selectedValue);
    setSelectedText(selectedValue?.text);
    if (name) {
      onChange(name, selectedValue.value);
    } else {
      onChange(selectedValue.value);
    }
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedValue(value);
    if (options && options.length > 0) {
      if (typeof value === 'object') {
        setSelectedText(value?.text || '');
      } else {
        const selectedOption = options.find(
          (option) => option?.value === value
        );
        setSelectedText(selectedOption ? selectedOption?.text : '');
      }
    }
  }, [value, options]);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (selectRef.current && !selectRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  const handleContainerClick = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const filteredOptions = options?.filter((option) =>
    option.text.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className={styles.selectContainer}>
      {label && (
        <label onClick={handleContainerClick}>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <div
        ref={selectRef}
        className={`${
          noborder
            ? styles.selectInpuNoBorders
            : errors && touched
            ? styles.error
            : styles.selectInput
        } ${isOpen ? styles.open : ''}`}
        onClick={handleContainerClick}
        style={{ border: grey ? '1px solid #0003b' : '' }}
      >
        <div
          className={styles.selectedValueicont}
          onClick={handleContainerClick}
        >
          {isOpen ? (
            <input
              type="text"
              placeholder={placeholder}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onClick={handleInputClick}
              className={styles.searchInput}
              autoFocus
            />
          ) : (
            <span
              className={`${styles.placeholder} ${
                selectedText ? styles.selectedText : ''
              }`}
            >
              {icon && <img src={icon} alt="icon" />}
              {selectedText ? selectedText : placeholder}
            </span>
          )}
          <img
            src={dropdownicon}
            alt="dropdown icon"
            className={styles.arrowIcon}
          />
        </div>
      </div>
      {isOpen && (
        <div className={styles.dropdown}>
          {filteredOptions?.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={option.value}
                className={
                  index % 2 === 0 ? styles.dropdownItem : styles.dropdownItemOdd
                }
                onClick={(e) => handleSelect(e, option)}
              >
                {status ? (
                  <StatusContainer status={option?.text} />
                ) : (
                  <div className={styles.dropdowncontainer}>{option?.text}</div>
                )}
              </div>
            ))
          ) : (
            <div className={styles.dropdownItem}>No options</div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomizedSelect;
